import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    decorator: {
      '&::before': {
        height: 4,
        width: 4,
        content: "''",
        marginRight: 8,
        borderRadius: 2,
        background: '#C8CACD',
        position: 'relative',
        display: 'inline-block'
      },
      display: 'flex',
      alignItems: 'center'
    }
  };
});